<template>
  <div :class="type" :style="{ height: height + 'px' }">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: "alert"
    },
    height: {
      type: Number,
      default: null
    }
  }
}
</script>


<style scoped>
.alert {
  background-color: rgba(236, 42, 66, 0.05);
  border-left: 4px solid #FF1D00;
  color: #FF1D00;
}

.alert-2 {
  background-color: rgba(223, 68, 48, 0.06);
  border-left: 4px solid #DF4430;
  color: #DF4430;
}

.warning {
  background: #FDF0E3;
  border-left: 3px solid #E0961E;
  color: #E0961E;
}

.success {
  background-color: #84BC3B0D;
  border-left: 4px solid #84BC3B;
  color: #84BC3B;
}

.info {
  border-left: 4px solid #3498DB;
  background: #EAF5FF;
  color: #3498DB;
}
</style>